var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("履约报表：")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData()
                }
              }
            },
            [_vm._v("\n      刷新\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "searchFormRef",
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采计划单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.plan_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "plan_id", $$v)
                                    },
                                    expression: "form.plan_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家ID" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_id", $$v)
                                    },
                                    expression: "form.supply_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("supply-select", {
                                  on: { change: _vm.changeSupplyId }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "市场",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.market_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "market_id", $$v)
                                      },
                                      expression: "form.market_id"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_market,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      clearable: "",
                                      placeholder: "请选择城市"
                                    },
                                    model: {
                                      value: _vm.form.arr_city_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "arr_city_id", $$v)
                                      },
                                      expression: "form.arr_city_id"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_supply_city,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "款号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_kh,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_kh", $$v)
                                    },
                                    expression: "form.goods_kh"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "filterable",
                                      placeholder: "代采组",
                                      multiple: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.arr_pg_group_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "arr_pg_group_id",
                                          $$v
                                        )
                                      },
                                      expression: "form.arr_pg_group_id"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_pg_group,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "filterable",
                                      placeholder: "代采员",
                                      multiple: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.arr_pg_member_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "arr_pg_member_id",
                                          $$v
                                        )
                                      },
                                      expression: "form.arr_pg_member_id"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_pg_member,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "计划生成方式",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.ptype,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "ptype", $$v)
                                      },
                                      expression: "form.ptype"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_ptype,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "代采类型",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.plan_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "plan_type", $$v)
                                      },
                                      expression: "form.plan_type"
                                    }
                                  },
                                  _vm._l(
                                    _vm.optionsData.options_plan_type,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "需求日期：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.demanded_date,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "demanded_date", $$v)
                                    },
                                    expression: "form.demanded_date"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      "true-label": "1",
                                      "false-label": "2"
                                    },
                                    model: {
                                      value: _vm.form.is_only_wait_plan,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "is_only_wait_plan",
                                          $$v
                                        )
                                      },
                                      expression: "form.is_only_wait_plan"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  只看有待开单\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "default" },
                                    on: { click: _vm.reset }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", [
                _vm._v("\n          数据列表\n          "),
                _c("span", { staticStyle: { color: "#4e9fe8" } }, [
                  _vm._v(
                    "\n            （数量/金额，金额按计划代采单统计）\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.exportDataExcel(_vm.exportType.EXPORT_LIST)
                        }
                      }
                    },
                    [_vm._v("\n            导出列表\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.exportDataExcel(
                            _vm.exportType.EXPORT_GOODS_DETAIL
                          )
                        }
                      }
                    },
                    [_vm._v("\n            导出商品明细\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.exportDataExcel(
                            _vm.exportType.EXPORT_GOODS_COMPLIANCE
                          )
                        }
                      }
                    },
                    [_vm._v("\n            导出商品履约\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.exportDataExcel(
                            _vm.exportType.EXPORT_DELIVERY_DAY_DETAIL
                          )
                        }
                      }
                    },
                    [_vm._v("\n            导出货期明细\n          ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData.list
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "row-class-name": _vm.tableRowClassName,
                          "show-summary": "",
                          "summary-method": _vm.summaryResults,
                          "max-height": 750
                        }
                      },
                      [
                        _c("el-table-column", {
                          key: "str_demanded_date",
                          attrs: {
                            align: "center",
                            prop: "str_demanded_date",
                            label: "需求日期",
                            fixed: "left"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "str_supply",
                            label: "商家",
                            "show-overflow-tooltip": "",
                            fixed: "left"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "str_pg_group",
                            label: "代采组",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "str_pg_member",
                            label: "代采员"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "24h_performance_rate",
                            label: "24H履约率"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  24H履约率"
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "\n                    统计需求日期当天（截止至晚上24点）已履约的金额占比\n                  "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "24H履约率 = 24H已履约金额 / 总需求金额"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1700671942
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "48h_performance_rate",
                            label: "48H履约率"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  48H履约率"
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "\n                    统计需求日期次日（截止至晚上24点）已履约的金额占比\n                  "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "48H履约率 = 48H已履约金额 / 总需求金额"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1910087154
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "360h_performance_rate",
                            label: "360H履约率"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  360H履约率"
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "\n                    统计需求日期15天内（截止至晚上24点）已履约的金额占比\n                  "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "360H履约率 = 360H已履约金额 / 总需求金额"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3508571527
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "final_performance_rate",
                            label: "总履约率"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  总履约率"
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "统计截止当前所有已履约的金额占比"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "总履约率 = 总已履约金额 / 总需求金额"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2621616539
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "delivery_accuracy",
                            label: "货期准确率"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  货期准确率"
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "统计商品到达承诺货期是所履约的金额占比"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "\n                    货期准确率=货期到期时已履约金额/订货单总需求金额*100%\n                  "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3237937241
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          { attrs: { align: "center", label: "总需求" } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                width: "100",
                                prop: "str_all_pre",
                                label: "前置仓发货"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    前置仓发货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(_vm._s(row.pre_num) + "/")
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.pre_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3012376112
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                width: "100",
                                prop: "str_all_inventory",
                                label: "现货发货"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    现货发货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                590163479
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_all_plan",
                                label: "订货单计划代采",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    订货单计划代采"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划中，总计划代采的商品数据。不含提前代采计划\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(_vm._s(row.plan_num) + "/")
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.plan_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1178762627
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_all_sum",
                                label: "小计",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    小计"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    总需求 = 前置仓发货 + 订货单计划代采\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(_vm._s(row.sum_num) + "/")
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.sum_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3924278266
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          { attrs: { align: "center", label: "已履约" } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_done_pre",
                                label: "前置仓发货",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    前置仓发货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.done_pre_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.done_pre_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2176726640
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                width: "100",
                                prop: "str_done_inventory",
                                label: "现货发货"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    现货发货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                590163479
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_done_plan",
                                label: "订货单正常品已入库（含坏账）",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    订货单正常品已入库（含坏账）"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划，开单后售前首次以正常品入库 或\n                    首次申请为坏账时计入。\n                    ①恢复欠货/正常品入库后调拨为不良品/坏账驳回均不再扣除。\n                    ②已计入履约的，不再重复计算。\n                    ③履约时间：代采欠货正常品入库-取生成包裹时间（快递包裹取揽收时间，无揽收时间时取仓库接收时间；无揽收时间且无接收时间时取最早的点货批次创建时间）；退换货欠货正常品入库\n                    - 取入库时间；申请坏账 - 申请坏账时间。\n                    ④入库来源=【代采欠货、退换货欠货、其它入库（退换货）】的退换区的商品被加入「商品盘亏表」时，消除「待履约」里的“退换货”，同时在“订货单正常品入库（含坏账）”里增加相应件数及金额。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.done_plan_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.done_plan_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                820735262
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_done_sum",
                                label: "小计",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    小计"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    已履约 = 前置仓发货 + 订货单正常品已入库（含坏账）\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(_vm._s(row.final_num) + "/")
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.final_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2477231576
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          { attrs: { align: "center", label: "待履约" } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_doing_plan",
                                label: "待开单",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    待开单"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前在待开单的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.doing_plan_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.doing_plan_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                558335539
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_doing_owe",
                                label: "订单欠货",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    订单欠货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前在订单欠货（含由订单欠货转退款中）的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.doing_owe_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.doing_owe_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1961090311
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_doing_on_way",
                                label: "配送在途",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    配送在途"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前在配送在途（即在途库存）、在途转欠货申请中的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.doing_on_way_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.doing_on_way_price)
                                            )
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2379476425
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_doing_reject",
                                label: "退换货",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    退换货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前为售前不良品在库、退换货待接收、退换货欠货、由售前退换货转退款中和转呆账的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.doing_reject_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.doing_reject_price)
                                            )
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1476875783
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_doing_sum",
                                label: "小计",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    小计"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    待履约 = 待开单 + 订单欠货 + 配送在途 + 退换货\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.sum_doing_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.sum_doing_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3521134065
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          { attrs: { align: "center", label: "未履约" } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_yet_stopped",
                                label: "已断货",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    已断货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前已断货的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.yet_stopped_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.yet_stopped_price)
                                            )
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                576057339
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_yet_ded",
                                label: "转抵扣",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    转抵扣"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前已转抵扣（含待抵扣、已抵扣、待抵扣转退款中）的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.yet_ded_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.yet_ded_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2023891672
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_yet_refund",
                                label: "已退款",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    已退款"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划当前已完成退款的商品数据。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.yet_refund_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.yet_refund_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3105793799
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_yet_cpin",
                                label: "次品入库",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    次品入库"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计对应需求时间的代采计划商品，因开单后售前首次以次品入库或退换货欠货首次以次品入库，均计入“次品入库”里；\n                    注意：恢复欠货并通过审核后，因商品重新回到代采欠货/在途库存，需要消掉对于的“次品入库”数据，并将数据返回到相应的表头记录里。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3728248193
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "str_yet_sum",
                                label: "小计",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    小计"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "未履约 = 已断货 + 转抵扣 + 已退款"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.sum_yet_num) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(row.sum_yet_price))
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1138026990
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          { attrs: { align: "center", label: "不考核" } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                width: "100",
                                prop: "not_evaluate_inventory_num",
                                label: "现货发货"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    现货发货"
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                row.not_evaluate_inventory_num
                                              ) + "/"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                row.not_evaluate_inventory_price
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3619174491
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClick(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                查看详情\n              "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1231903380
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.form.page,
                        "page-size": _vm.form.page_size,
                        "page-sizes": [10, 20, 30, 50, 100],
                        background: "",
                        layout: "total, prev, pager, next, jumper,sizes ",
                        total: _vm.resData.count
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca1bffda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca1bffda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PerformanceReport/index.vue
// module id = null
// module chunks = 